import { render } from "./VisitorsPage.vue?vue&type=template&id=46a2a099"
import script from "./VisitorsPage.vue?vue&type=script&lang=js"
export * from "./VisitorsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__